import React from 'react';
import { Plus, X, Upload } from 'lucide-react';
import i18n from '../../../../../i18n';


export class GroupForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                organization: '',
                sector_id: '',
                actual_start_date: '',
                expected_end_date: '',
                project_code: '',
                group_name: '',
                group_name_ar: '',
                manager: '',
                hse: '',
                reg_start_date: '',
                reg_end_date: '',
                start_date: '',
                end_date: '',
                amount: '',
                visit_amount: '',
                vat: '',
                service_charge: '',
                client_service_charge: '',
                payment_type: '',
                is_auctions_grouped: false,
                is_grouped_enroll: false,
                is_extra_time: true,
                extra_time: 2,
                has_auto_bidding: false,
                is_service_charge_included: false,
                service_charge_included: 0,
                is_service_charge_vat_included: false,
                is_vat_included: false,
                terms: '',
                terms_arabic: '',
                client: {
                    focal_name: '',
                    client_name: '',
                    mobile: '',
                    email: ''
                }
            },
            enquiries: [
                { label: '', value: '', label_ar: '', value_ar: '' }
            ],
            files: {
                file_group_image: null,
                file_terms: null,
                file_payment_terms: null
            }
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.addEnquiry = this.addEnquiry.bind(this);
        this.removeEnquiry = this.removeEnquiry.bind(this);
        this.updateEnquiry = this.updateEnquiry.bind(this);
    }

    handleChange(e) {
        const { name, value, type, checked } = e.target;

        this.setState(prevState => {
            const formData = { ...prevState.formData };

            if (name.includes('.')) {
                const [parent, child] = name.split('.');
                formData[parent] = {
                    ...formData[parent],
                    [child]: value
                };
            } else {
                formData[name] = type === 'checkbox' ? checked : value;
            }

            return { formData };
        });
    }

    handleFileChange(e) {
        const { name, files } = e.target;
        this.setState(prevState => ({
            files: {
                ...prevState.files,
                [name]: files[0]
            }
        }));
    }

    addEnquiry(e) {
        e.preventDefault();
        this.setState(prevState => ({
            enquiries: [...prevState.enquiries, { label: '', value: '', label_ar: '', value_ar: '' }]
        }));
    }

    removeEnquiry(index) {
        this.setState(prevState => ({
            enquiries: prevState.enquiries.filter((_, i) => i !== index)
        }));
    }

    updateEnquiry(index, field, value) {
        this.setState(prevState => {
            const enquiries = [...prevState.enquiries];
            enquiries[index][field] = value;
            return { enquiries };
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        const payload = {
            ...this.state.formData,
            enquiries: this.state.enquiries,
            ...this.state.files
        };
        this.props.onSubmit(payload);
    }

    render() {
        const { managers = [], hseUsers = [], organizations = [], sectors = [] } = this.props;
        const { formData, enquiries, files } = this.state;

        return (
            <div className="modern-form-container">
                <form onSubmit={this.handleSubmit} className="modern-form">
                    <div className="form-header">
                        <h2>Create New Group</h2>
                    </div>

                    {/* Client Information Section */}
                    <div className="form-section">
                        <h3 className="section-title">Client Information</h3>
                        <div className="form-grid">
                            <div className="form-field">
                                <label>Client Name <span className="required">*</span></label>
                                <select
                                    name="organization"
                                    value={formData.organization}
                                    onChange={this.handleChange}
                                >
                                    <option value="">Select Client</option>
                                    {organizations.map(org => (
                                        <option key={org.id} value={org.id}>{org.organization_name}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-field">
                                <label>Sector <span className="required">*</span></label>
                                <select
                                    name="sector_id"
                                    value={formData.sector_id}
                                    onChange={this.handleChange}
                                >
                                    <option value="">Select Sector</option>
                                    {sectors.map(sector => (
                                        <option key={sector.id} value={sector.id}>{sector.name}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-field">
                                <label>Focal Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    name="client.focal_name"
                                    value={formData.client?.focal_name || ''}
                                    onChange={this.handleChange}
                                    placeholder="Enter focal name"
                                />
                            </div>

                            <div className="form-field">
                                <label>Client Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    name="client.client_name"
                                    value={formData.client?.client_name || ''}
                                    onChange={this.handleChange}
                                    placeholder="Enter client name"
                                />
                            </div>

                            <div className="form-field">
                                <label>Mobile <span className="required">*</span></label>
                                <input
                                    type="text"
                                    name="client.mobile"
                                    value={formData.client?.mobile || ''}
                                    onChange={this.handleChange}
                                    placeholder="Enter mobile number"
                                />
                            </div>

                            <div className="form-field">
                                <label>Email <span className="required">*</span></label>
                                <input
                                    type="email"
                                    name="client.email"
                                    value={formData.client?.email || ''}
                                    onChange={this.handleChange}
                                    placeholder="Enter email"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Project Details Section */}
                    <div className="form-section">
                        <h3 className="section-title">Project Details</h3>
                        <div className="form-grid">
                            <div className="form-field">
                                <label>Project Code <span className="required">*</span></label>
                                <input
                                    type="text"
                                    name="project_code"
                                    value={formData.project_code}
                                    onChange={this.handleChange}
                                    placeholder="Enter project code"
                                />
                            </div>

                            <div className="form-field">
                                <label>Group Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    name="group_name"
                                    value={formData.group_name}
                                    onChange={this.handleChange}
                                    placeholder="Enter group name"
                                />
                            </div>

                            <div className="form-field">
                                <label>Group Name (Arabic) <span className="required">*</span></label>
                                <input
                                    type="text"
                                    name="group_name_ar"
                                    value={formData.group_name_ar}
                                    onChange={this.handleChange}
                                    placeholder="أدخل اسم المجموعة"
                                    style={{ direction: 'rtl' }}
                                />
                            </div>

                            <div className="form-field">
                                <label>Actual Start Date <span className="required">*</span></label>
                                <input
                                    type="date"
                                    name="actual_start_date"
                                    value={formData.actual_start_date}
                                    onChange={this.handleChange}
                                />
                            </div>

                            <div className="form-field">
                                <label>Expected End Date <span className="required">*</span></label>
                                <input
                                    type="date"
                                    name="expected_end_date"
                                    value={formData.expected_end_date}
                                    onChange={this.handleChange}
                                />
                            </div>

                            <div className="form-field">
                                <label>Project Manager <span className="required">*</span></label>
                                <select
                                    name="manager"
                                    value={formData.manager}
                                    onChange={this.handleChange}
                                >
                                    <option value="">Select Manager</option>
                                    {managers.map(manager => (
                                        <option key={manager.id} value={manager.id}>{manager.name}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-field">
                                <label>Safety Officer <span className="required">*</span></label>
                                <select
                                    name="hse"
                                    value={formData.hse}
                                    onChange={this.handleChange}
                                >
                                    <option value="">Select Safety Officer</option>
                                    {hseUsers.map(user => (
                                        <option key={user.id} value={user.id}>{user.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Auction Dates Section */}
                    <div className="form-section">
                        <h3 className="section-title">Auction Schedule</h3>
                        <div className="form-grid">
                            <div className="form-field">
                                <label>Registration Start <span className="required">*</span></label>
                                <input
                                    type="datetime-local"
                                    name="reg_start_date"
                                    value={formData.reg_start_date}
                                    onChange={this.handleChange}
                                />
                            </div>

                            <div className="form-field">
                                <label>Registration End <span className="required">*</span></label>
                                <input
                                    type="datetime-local"
                                    name="reg_end_date"
                                    value={formData.reg_end_date}
                                    onChange={this.handleChange}
                                />
                            </div>

                            <div className="form-field">
                                <label>Auction Start <span className="required">*</span></label>
                                <input
                                    type="datetime-local"
                                    name="start_date"
                                    value={formData.start_date}
                                    onChange={this.handleChange}
                                />
                            </div>

                            <div className="form-field">
                                <label>Auction End <span className="required">*</span></label>
                                <input
                                    type="datetime-local"
                                    name="end_date"
                                    value={formData.end_date}
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Financial Details Section */}
                    <div className="form-section">
                        <h3 className="section-title">Financial Details</h3>
                        <div className="form-grid">
                            <div className="form-field">
                                <label>Enroll Amount</label>
                                <input
                                    type="number"
                                    name="amount"
                                    value={formData.amount}
                                    onChange={this.handleChange}
                                    placeholder="0.00"
                                />
                            </div>

                            <div className="form-field">
                                <label>{i18n.t('site_visit_amount')}</label>
                                <input
                                    type="number"
                                    name="visit_amount"
                                    value={formData.visit_amount}
                                    onChange={this.handleChange}
                                    placeholder="0.00"
                                />
                            </div>

                            <div className="form-field">
                                <label>{i18n.t('vat')}(%)</label>
                                <input
                                    type="number"
                                    name="vat"
                                    value={formData.vat}
                                    onChange={this.handleChange}
                                    placeholder="0"
                                />
                            </div>

                            <div className="form-field">
                                <label> {i18n.t('mzadcom_service_charge')}(%)</label>
                                <input
                                    type="number"
                                    name="service_charge"
                                    value={formData.service_charge}
                                    onChange={this.handleChange}
                                    placeholder="0"
                                />
                            </div>

                            <div className="form-field">
                                <label> {i18n.t('client_service_charge')}(%)</label>
                                <input
                                    type="number"
                                    name="client_service_charge"
                                    value={formData.client_service_charge}
                                    onChange={this.handleChange}
                                    placeholder="0"
                                />
                            </div>

                            <div className="form-field">
                                <label>{i18n.t('pay_type')}</label>
                                <select
                                    name="payment_type"
                                    value={formData.payment_type}
                                    onChange={this.handleChange}
                                >
                                    <option value="">Select Payment Type</option>
                                    <option value="Online">{i18n.t('online')}</option>
                                    <option value="Offline">{i18n.t('offline')}</option>
                                    <option value="Both">All Payment Methods</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Toggle Options Section */}
                    <div className="form-section">
                        <h3 className="section-title">Options</h3>
                        <div className="toggle-grid">
                            <label className="toggle-field">
                                <input
                                    type="checkbox"
                                    name="is_auctions_grouped"
                                    checked={formData.is_auctions_grouped}
                                    onChange={this.handleChange}
                                />
                                <span>Auctions Grouped</span>
                            </label>

                            <label className="toggle-field">
                                <input
                                    type="checkbox"
                                    name="is_grouped_enroll"
                                    checked={formData.is_grouped_enroll}
                                    onChange={this.handleChange}
                                />
                                <span>Grouped Enroll</span>
                            </label>

                            <label className="toggle-field">
                                <input
                                    type="checkbox"
                                    name="has_auto_bidding"
                                    checked={formData.has_auto_bidding}
                                    onChange={this.handleChange}
                                />
                                <span>Auto Bidding</span>
                            </label>

                 
                        </div>

                       

                        <div className="extra-time-section">
                            <label className="toggle-field">
                                <input
                                    type="checkbox"
                                    name="is_extra_time"
                                    checked={formData.is_extra_time}
                                    onChange={this.handleChange}
                                />
                                <span>Extra Time</span>
                            </label>
                            {formData.is_extra_time && (
                                <input
                                    type="number"
                                    name="extra_time"
                                    value={formData.extra_time}
                                    onChange={this.handleChange}
                                    placeholder="Minutes"
                                    className="extra-time-input"
                                />
                            )}
                        </div>
                    </div>

                    <div className="form-section">
                        <h3 className="section-title">For Client Payment</h3>
                        <div className="toggle-grid">

                            <label className="toggle-field">
                                <input
                                    type="checkbox"
                                    name="is_vat_included"
                                    checked={formData.is_vat_included}
                                    onChange={this.handleChange}
                                />
                                <span>VAT Included</span>
                            </label>

                            <label className="toggle-field">
                                <input
                                    type="checkbox"
                                    name="is_service_charge_included"
                                    checked={formData.is_service_charge_included}
                                    onChange={this.handleChange}
                                />
                                <span>Service Charge Included</span>
                            </label>

                            

                            <label className="toggle-field">
                                <input
                                    type="checkbox"
                                    name="is_service_charge_vat_included"
                                    checked={formData.is_service_charge_vat_included}
                                    onChange={this.handleChange}
                                />
                                <span>Service Charge VAT Included</span>
                            </label>
                        </div>

                        {formData.is_service_charge_included && (
                            <div className="form-field" style={{ marginTop: '1rem' }}>
                                <label>Service Charge Amount (%)</label>
                                <input
                                    type="number"
                                    name="service_charge_included"
                                    value={formData.service_charge_included}
                                    onChange={this.handleChange}
                                    placeholder="0"
                                    min="0"
                                    max="100"
                                />
                            </div>
                        )}


                    </div>

                    {/* File Uploads Section */}
                    <div className="form-section">
                        <h3 className="section-title">Documents</h3>
                        <div className="form-grid">
                            <div className="form-field">
                                <label>Group Image</label>
                                <div className="file-upload">
                                    <Upload size={20} />
                                    <input
                                        type="file"
                                        name="file_group_image"
                                        onChange={this.handleFileChange}
                                        accept="image/*"
                                    />
                                    <span>{files.file_group_image?.name || 'Choose file'}</span>
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Terms & Conditions (PDF)</label>
                                <div className="file-upload">
                                    <Upload size={20} />
                                    <input
                                        type="file"
                                        name="file_terms"
                                        onChange={this.handleFileChange}
                                        accept="application/pdf"
                                    />
                                    <span>{files.file_terms?.name || 'Choose file'}</span>
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Payment Terms (PDF)</label>
                                <div className="file-upload">
                                    <Upload size={20} />
                                    <input
                                        type="file"
                                        name="file_payment_terms"
                                        onChange={this.handleFileChange}
                                        accept="application/pdf"
                                    />
                                    <span>{files.file_payment_terms?.name || 'Choose file'}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Terms Section */}
                    <div className="form-section">
                        <h3 className="section-title">Terms & Conditions</h3>
                        <div className="form-field full-width">
                            <label>Terms & Conditions (English)</label>
                            <textarea
                                name="terms"
                                value={formData.terms}
                                onChange={this.handleChange}
                                rows="5"
                                placeholder="Enter terms and conditions"
                            />
                        </div>

                        <div className="form-field full-width">
                            <label>Terms & Conditions (Arabic)</label>
                            <textarea
                                name="terms_arabic"
                                value={formData.terms_arabic}
                                onChange={this.handleChange}
                                rows="5"
                                placeholder="أدخل الشروط والأحكام"
                                style={{ direction: 'rtl' }}
                            />
                        </div>
                    </div>

                    {/* Enquiries Section */}
                    <div className="form-section">
                        <div className="section-header">
                            <h3 className="section-title">Enquiries</h3>
                            <button type="button" onClick={this.addEnquiry} className="btn-icon">
                                <Plus size={18} /> Add Enquiry
                            </button>
                        </div>

                        {enquiries.map((enquiry, index) => (
                            <div key={index} className="enquiry-row">
                                <input
                                    type="text"
                                    placeholder="Label"
                                    value={enquiry.label}
                                    onChange={(e) => this.updateEnquiry(index, 'label', e.target.value)}
                                />
                                <input
                                    type="text"
                                    placeholder="Value"
                                    value={enquiry.value}
                                    onChange={(e) => this.updateEnquiry(index, 'value', e.target.value)}
                                />
                                <input
                                    type="text"
                                    placeholder="Label (Arabic)"
                                    value={enquiry.label_ar}
                                    onChange={(e) => this.updateEnquiry(index, 'label_ar', e.target.value)}
                                    style={{ direction: 'rtl' }}
                                />
                                <input
                                    type="text"
                                    placeholder="Value (Arabic)"
                                    value={enquiry.value_ar}
                                    onChange={(e) => this.updateEnquiry(index, 'value_ar', e.target.value)}
                                    style={{ direction: 'rtl' }}
                                />
                                {index > 0 && (
                                    <button
                                        type="button"
                                        onClick={() => this.removeEnquiry(index)}
                                        className="btn-remove"
                                    >
                                        <X size={18} />
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* Form Actions */}
                    <div className="form-actions">
                        <button type="submit" className="btn-primary">
                            Create Group
                        </button>
                        <button type="button" onClick={this.props.onCancel} className="btn-secondary">
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

